import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "home-wage-retirement-compare-modal" }
const _hoisted_2 = { class: "home-wage-retirement-compare-modal__header" }
const _hoisted_3 = { class: "home-wage-retirement-compare-modal__toolbar" }
const _hoisted_4 = { class: "home-wage-retirement-compare-modal__toolbar-left" }
const _hoisted_5 = { class: "rc-tool-count" }
const _hoisted_6 = { class: "home-wage-retirement-compare-modal__toolbar-right" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "home-wage-retirement-compare-modal__summary" }
const _hoisted_9 = { class: "home-wage-retirement-compare-modal__table-wrap" }
const _hoisted_10 = { class: "home-wage-retirement-compare-modal__table" }
const _hoisted_11 = { class: "col-check" }
const _hoisted_12 = ["checked"]
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "col-check" }
const _hoisted_15 = ["onUpdate:modelValue"]
const _hoisted_16 = { class: "col-order" }
const _hoisted_17 = ["disabled", "onClick"]
const _hoisted_18 = ["disabled", "onClick"]
const _hoisted_19 = { class: "col-seq" }
const _hoisted_20 = { class: "col-name" }
const _hoisted_21 = { class: "col-hours" }
const _hoisted_22 = { class: "col-pay" }
const _hoisted_23 = { class: "col-amt" }
const _hoisted_24 = { class: "col-amt" }
const _hoisted_25 = { class: "home-wage-retirement-compare-modal__footer" }

import { computed, onBeforeUnmount, ref } from 'vue';
import {
  buildHomeWageRetirementCompareRow,
  type HomeWageRetirementCompareRow,
} from '@/policies/homeWageSettingPolicy';

type CompareListRow = HomeWageRetirementCompareRow & {
  rowKey: string;
  checked: boolean;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeWageRetirementCompareModal',
  setup(__props, { expose: __expose }) {

const dialog = ref(false);
const yearMonth = ref('');
const memberName = ref('');
const rows = ref<CompareListRow[]>([]);
let printFrame: HTMLIFrameElement | null = null;

const yearLabel = computed(() => {
  const ym = yearMonth.value.replace(/\D/g, '').slice(0, 6);
  if (ym.length !== 6) return yearMonth.value || '-';
  return `${ym.slice(0, 4)}년 ${Number(ym.slice(4, 6))}월`;
});

const selectedRows = computed(() => rows.value.filter((r) => r.checked));
const selectedCount = computed(() => selectedRows.value.length);
const allSelected = computed(
  () => rows.value.length > 0 && rows.value.every((r) => r.checked)
);

const sumSelectedCustomer = computed(() =>
  selectedRows.value.reduce(
    (s, r) => s + (r.retirementEligible ? Number(r.customerRetirement) || 0 : 0),
    0
  )
);
const sumSelectedCaion = computed(() =>
  selectedRows.value.reduce(
    (s, r) => s + (r.retirementEligible ? Number(r.caionRetirement) || 0 : 0),
    0
  )
);

const formatMoney = (n: number) => (Number(n) || 0).toLocaleString('ko-KR');
const formatHours = (h: number) => {
  const n = Number(h) || 0;
  if (n <= 0) return '-';
  return Number.isInteger(n) ? `${n}` : String(Math.round(n * 10) / 10);
};
const formatRetirement = (amount: number, eligible: boolean) =>
  (eligible ? formatMoney(amount) : '-');

const selectAll = () => {
  rows.value.forEach((r) => {
    r.checked = true;
  });
};

/** 60h 이상 · 고객/카이온 퇴직금이 1원 이상인 사람만 선택 */
const selectWithRetirement = () => {
  rows.value.forEach((r) => {
    r.checked =
      r.retirementEligible
      && ((Number(r.customerRetirement) || 0) > 0 || (Number(r.caionRetirement) || 0) > 0);
  });
};

const clearSelection = () => {
  rows.value.forEach((r) => {
    r.checked = false;
  });
};

const toggleSelectAll = (checked: boolean) => {
  rows.value.forEach((r) => {
    r.checked = checked;
  });
};

const onToggleSelectAll = (event: Event) => {
  const target = event.target as HTMLInputElement | null;
  toggleSelectAll(!!target?.checked);
};

const moveRow = (index: number, delta: number) => {
  const next = index + delta;
  if (next < 0 || next >= rows.value.length) return;
  const list = [...rows.value];
  const [item] = list.splice(index, 1);
  list.splice(next, 0, item);
  rows.value = list.map((r, i) => ({ ...r, seq: i + 1 }));
};

const escapeHtml = (value: string) =>
  String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');

const removePrintFrame = () => {
  if (printFrame?.parentNode) {
    printFrame.parentNode.removeChild(printFrame);
  }
  printFrame = null;
};

const printSelected = () => {
  const list = selectedRows.value;
  if (list.length === 0) {
    alert('출력할 사람을 체크해 주세요.');
    return;
  }

  const facility = memberName.value || '시설';
  const title = `${facility} ${yearLabel.value} 퇴직금 비교`;
  const bodyRows = list
    .map((row, idx) => {
      const noteClass = !row.retirementEligible
        ? 'under60'
        : row.diffAmount === 0
          ? 'match'
          : 'diff';
      return `
      <tr class="${noteClass}">
        <td class="c">${idx + 1}</td>
        <td>${escapeHtml(row.name)}</td>
        <td class="r">${escapeHtml(formatHours(row.workHours))}</td>
        <td class="r">${formatMoney(row.grossPay)}</td>
        <td class="r">${escapeHtml(formatRetirement(row.customerRetirement, row.retirementEligible))}</td>
        <td class="r">${escapeHtml(formatRetirement(row.caionRetirement, row.retirementEligible))}</td>
        <td class="note">${escapeHtml(row.note)}</td>
      </tr>`;
    })
    .join('');

  const sumCustomer = list.reduce(
    (s, r) => s + (r.retirementEligible ? Number(r.customerRetirement) || 0 : 0),
    0
  );
  const sumCaion = list.reduce(
    (s, r) => s + (r.retirementEligible ? Number(r.caionRetirement) || 0 : 0),
    0
  );

  const html = `<!DOCTYPE html>
<html lang="ko">
<head>
  <meta charset="utf-8">
  <title>${escapeHtml(title)}</title>
  <style>
    * { box-sizing: border-box; }
    body { margin: 24px; font-family: "Malgun Gothic", "Apple SD Gothic Neo", sans-serif; color: #1e293b; }
    h1 { margin: 0 0 6px; font-size: 18px; }
    .meta { margin: 0 0 14px; font-size: 12px; color: #64748b; }
    table { width: 100%; border-collapse: collapse; font-size: 12px; }
    th, td { border: 1px solid #cbd5e1; padding: 6px 8px; }
    th { background: #f1f5f9; text-align: left; }
    td.c { text-align: center; width: 40px; }
    td.r { text-align: right; white-space: nowrap; font-variant-numeric: tabular-nums; }
    tr.diff { background: #fffbeb; }
    td.note { font-weight: 600; }
    tr.match td.note { color: #15803d; }
    tr.diff td.note { color: #b45309; }
    tr.under60 td.note { color: #64748b; font-weight: 500; }
    tfoot td { font-weight: 700; background: #f8fafc; }
    @media print {
      body { margin: 12px; }
    }
  </style>
</head>
<body>
  <h1>${escapeHtml(title)}</h1>
  <p class="meta">출력 ${list.length}명 · 고객합계 ${formatMoney(sumCustomer)}원 · 카이온합계 ${formatMoney(sumCaion)}원 · 차이 ${formatMoney(sumCustomer - sumCaion)}원</p>
  <table>
    <thead>
      <tr>
        <th>순번</th>
        <th>이름</th>
        <th>근무시간</th>
        <th>급여</th>
        <th>고객계산퇴직금</th>
        <th>카이온계산퇴직금</th>
        <th>비고</th>
      </tr>
    </thead>
    <tbody>${bodyRows}</tbody>
    <tfoot>
      <tr>
        <td colspan="4">합계</td>
        <td class="r">${formatMoney(sumCustomer)}</td>
        <td class="r">${formatMoney(sumCaion)}</td>
        <td></td>
      </tr>
    </tfoot>
  </table>
</body>
</html>`;

  removePrintFrame();
  const iframe = document.createElement('iframe');
  iframe.setAttribute('title', '퇴직금 비교 출력');
  iframe.style.position = 'fixed';
  iframe.style.right = '0';
  iframe.style.bottom = '0';
  iframe.style.width = '0';
  iframe.style.height = '0';
  iframe.style.border = '0';
  iframe.style.opacity = '0';
  iframe.style.pointerEvents = 'none';
  document.body.appendChild(iframe);
  printFrame = iframe;

  const frameWindow = iframe.contentWindow;
  const frameDoc = iframe.contentDocument || frameWindow?.document;
  if (!frameWindow || !frameDoc) {
    removePrintFrame();
    alert('출력 준비에 실패했습니다. 잠시 후 다시 시도해 주세요.');
    return;
  }

  frameDoc.open();
  frameDoc.write(html);
  frameDoc.close();

  const runPrint = () => {
    try {
      frameWindow.focus();
      frameWindow.print();
    } catch (error) {
      console.error('퇴직금 비교 출력 오류:', error);
      alert('출력 중 오류가 발생했습니다.');
    } finally {
      window.setTimeout(removePrintFrame, 1000);
    }
  };

  // 브라우저별 문서 로드 타이밍 보정
  window.setTimeout(runPrint, 150);
};

const open = (payload: {
  yearMonth: string;
  wageRows: Record<string, unknown>[];
  memberName?: string;
}) => {
  yearMonth.value = payload.yearMonth || '';
  memberName.value = String(payload.memberName || '').trim();
  const list = Array.isArray(payload.wageRows) ? payload.wageRows : [];
  rows.value = list
    .map((row, idx) => buildHomeWageRetirementCompareRow(row, idx + 1, yearMonth.value))
    .map((row, idx) => ({
      ...row,
      seq: idx + 1,
      rowKey: `${row.name}|${row.workHours}|${row.grossPay}|${idx}`,
      checked: true,
    }));
  dialog.value = true;
};

const close = () => {
  dialog.value = false;
};

onBeforeUnmount(() => {
  removePrintFrame();
});

__expose({ open, close });

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: dialog.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dialog).value = $event)),
    "max-width": "1320px",
    persistent: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("header", _hoisted_2, [
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "home-wage-retirement-compare-modal__title-wrap" }, [
            _createElementVNode("h2", { class: "home-wage-retirement-compare-modal__title" }, "퇴직금 비교 (고객 vs 카이온)"),
            _createElementVNode("span", { class: "admin-only-chip" }, "최고관리자")
          ], -1)),
          _createElementVNode("button", {
            type: "button",
            class: "home-wage-retirement-compare-modal__close",
            "aria-label": "닫기",
            onClick: close
          }, [
            _createVNode(_component_v_icon, { size: "20" }, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                _createTextVNode("mdi-close", -1)
              ]))]),
              _: 1
            })
          ])
        ]),
        _cache[18] || (_cache[18] = _createElementVNode("p", { class: "home-wage-retirement-compare-modal__desc" }, " 출력할 사람을 체크하고 ↑↓로 순서를 바꾼 뒤 「선택 출력」하면, 체크된 사람만 현재 순서대로 인쇄됩니다. 월 60시간 미만은 퇴직금 대상이 아니므로 「-」로 표시합니다. ", -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              type: "button",
              class: "rc-tool-btn",
              onClick: selectAll
            }, "전체선택"),
            _createElementVNode("button", {
              type: "button",
              class: "rc-tool-btn",
              onClick: selectWithRetirement
            }, "퇴직금 있는 사람만"),
            _createElementVNode("button", {
              type: "button",
              class: "rc-tool-btn",
              onClick: clearSelection
            }, "선택해제"),
            _createElementVNode("span", _hoisted_5, "선택 " + _toDisplayString(selectedCount.value) + " / " + _toDisplayString(rows.value.length) + "명", 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              type: "button",
              class: "rc-tool-btn rc-tool-btn--primary",
              disabled: selectedCount.value === 0,
              onClick: printSelected
            }, [
              _createVNode(_component_v_icon, { size: "14" }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createTextVNode("mdi-printer", -1)
                ]))]),
                _: 1
              }),
              _cache[4] || (_cache[4] = _createTextVNode(" 선택 출력 ", -1))
            ], 8, _hoisted_7)
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("span", null, _toDisplayString(yearLabel.value) + " · 전체 " + _toDisplayString(rows.value.length) + "명", 1),
          _createElementVNode("span", null, "선택 고객합계 " + _toDisplayString(formatMoney(sumSelectedCustomer.value)) + "원", 1),
          _createElementVNode("span", null, "선택 카이온합계 " + _toDisplayString(formatMoney(sumSelectedCaion.value)) + "원", 1),
          _createElementVNode("span", null, "선택 차이 " + _toDisplayString(formatMoney(sumSelectedCustomer.value - sumSelectedCaion.value)) + "원", 1)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("table", _hoisted_10, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", _hoisted_11, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    checked: allSelected.value,
                    title: "전체선택",
                    onChange: onToggleSelectAll
                  }, null, 40, _hoisted_12)
                ]),
                _cache[5] || (_cache[5] = _createElementVNode("th", { class: "col-order" }, "순서", -1)),
                _cache[6] || (_cache[6] = _createElementVNode("th", { class: "col-seq" }, "순번", -1)),
                _cache[7] || (_cache[7] = _createElementVNode("th", { class: "col-name" }, "이름", -1)),
                _cache[8] || (_cache[8] = _createElementVNode("th", { class: "col-hours" }, "근무시간", -1)),
                _cache[9] || (_cache[9] = _createElementVNode("th", { class: "col-pay" }, "급여", -1)),
                _cache[10] || (_cache[10] = _createElementVNode("th", { class: "col-amt" }, "고객계산퇴직금", -1)),
                _cache[11] || (_cache[11] = _createElementVNode("th", { class: "col-amt" }, "카이온계산퇴직금", -1)),
                _cache[12] || (_cache[12] = _createElementVNode("th", { class: "col-note" }, "비고", -1))
              ])
            ]),
            _createElementVNode("tbody", null, [
              (rows.value.length === 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_13, [...(_cache[13] || (_cache[13] = [
                    _createElementVNode("td", {
                      colspan: "9",
                      class: "col-empty"
                    }, "비교할 임금 데이터가 없습니다.", -1)
                  ]))]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rows.value, (row, idx) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: row.rowKey,
                  class: _normalizeClass({
                'is-diff': row.retirementEligible && row.diffAmount !== 0,
                'is-match': row.retirementEligible && row.diffAmount === 0,
                'is-under60': !row.retirementEligible,
                'is-checked': row.checked,
              })
                }, [
                  _createElementVNode("td", _hoisted_14, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": ($event: any) => ((row.checked) = $event),
                      type: "checkbox"
                    }, null, 8, _hoisted_15), [
                      [_vModelCheckbox, row.checked]
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_16, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "rc-order-btn",
                      disabled: idx === 0,
                      title: "위로",
                      onClick: ($event: any) => (moveRow(idx, -1))
                    }, [
                      _createVNode(_component_v_icon, { size: "16" }, {
                        default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                          _createTextVNode("mdi-chevron-up", -1)
                        ]))]),
                        _: 1
                      })
                    ], 8, _hoisted_17),
                    _createElementVNode("button", {
                      type: "button",
                      class: "rc-order-btn",
                      disabled: idx === rows.value.length - 1,
                      title: "아래로",
                      onClick: ($event: any) => (moveRow(idx, 1))
                    }, [
                      _createVNode(_component_v_icon, { size: "16" }, {
                        default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                          _createTextVNode("mdi-chevron-down", -1)
                        ]))]),
                        _: 1
                      })
                    ], 8, _hoisted_18)
                  ]),
                  _createElementVNode("td", _hoisted_19, _toDisplayString(idx + 1), 1),
                  _createElementVNode("td", _hoisted_20, _toDisplayString(row.name), 1),
                  _createElementVNode("td", _hoisted_21, _toDisplayString(formatHours(row.workHours)), 1),
                  _createElementVNode("td", _hoisted_22, _toDisplayString(formatMoney(row.grossPay)), 1),
                  _createElementVNode("td", _hoisted_23, _toDisplayString(formatRetirement(row.customerRetirement, row.retirementEligible)), 1),
                  _createElementVNode("td", _hoisted_24, _toDisplayString(formatRetirement(row.caionRetirement, row.retirementEligible)), 1),
                  _createElementVNode("td", {
                    class: _normalizeClass(["col-note", {
                  'col-note--match': row.retirementEligible && row.diffAmount === 0,
                  'col-note--diff': row.retirementEligible && row.diffAmount !== 0,
                  'col-note--under60': !row.retirementEligible,
                }])
                  }, _toDisplayString(row.note), 3)
                ], 2))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("footer", _hoisted_25, [
          _createVNode(_component_v_btn, {
            variant: "flat",
            class: "btn-print",
            disabled: selectedCount.value === 0,
            onClick: printSelected
          }, {
            default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
              _createTextVNode(" 선택 출력 ", -1)
            ]))]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_v_btn, {
            variant: "flat",
            class: "btn-close",
            onClick: close
          }, {
            default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
              _createTextVNode("닫기", -1)
            ]))]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})